import React from 'react'
import { CMS_BLOCK } from 'app/sofia/resources/constants'
import { Container } from './styled'
import { useCmsBlock } from 'lib/core/hooks'

export const FeaturedCategories = () => {
  const staticBlockID = CMS_BLOCK.HOME_CATEGORIES
  const staticBlock = useCmsBlock({
    id: staticBlockID,
    isLazy: false
  })

  if (!staticBlock.content) return null
  return (
    <Container>
      <div
        dangerouslySetInnerHTML={{
          __html: staticBlock?.content ?? ''
        }}
      />
    </Container>
  )
}
